'use client'

import * as React from 'react'
import {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  Bell,
  BellRing,
  CheckCircle,
  Info,
  Lightbulb,
  Megaphone,
  Shield,
  ShieldAlert,
  XCircle,
} from 'lucide-react'

import cn from '@config/tailwind/cn'

import { Alert, AlertDescription, AlertTitle } from '../../components/alert'

const iconMap = {
  AlertCircle,
  AlertTriangle,
  Info,
  CheckCircle,
  XCircle,
  AlertOctagon,
  Bell,
  BellRing,
  Shield,
  ShieldAlert,
  Lightbulb,
  Megaphone,
} as const

type IconName = keyof typeof iconMap

interface AlertBlockFields {
  blockType: 'alert'
  variant: 'default' | 'destructive'
  title: string
  description?: string
  icon?: IconName | ''
}

interface AlertBlockProps {
  fields: AlertBlockFields
}

const variantMap = {
  default: 'neutral',
  destructive: 'error',
} as const

export function AlertBlock({ fields }: AlertBlockProps) {
  const Icon = fields.icon ? iconMap[fields.icon] : null
  const isDestructive = fields.variant === 'destructive'

  return (
    <div className='ui:my-6'>
      <Alert
        variant={variantMap[fields.variant]}
        className={cn(
          isDestructive ? 'ui:bg-error-container' : 'ui:bg-blue-10',
          isDestructive ? 'ui:border-error' : 'ui:border-blue-50',
          'ui:text-neutral-black',
        )}
      >
        {Icon && <Icon className={cn(isDestructive ? 'ui:text-error' : 'ui:text-blue-100')} />}
        {fields.title && (
          <AlertTitle className={cn(isDestructive ? 'ui:text-error' : 'ui:text-blue-100')}>{fields.title}</AlertTitle>
        )}
        {fields.description && (
          <AlertDescription className='ui:text-neutral-black'>{fields.description}</AlertDescription>
        )}
      </Alert>
    </div>
  )
}
